import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import webapi from './webapi'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		count: 55,
		Stations: [],
		//设备参数模板
		EquipmentModelDefine: [],
		//价格模板
		priceModelDefine: [],
		priceModelPowerDefine: [],
		priceModelJfpgDefine: [],
		//供应商模板
		typeList: [],
		ManufacturerList: [],
		//角色模板
		roleList: [],
		//当前登录用户信息
		CurrentUserInfo: {},
		chargeFronterList: [],
		StationParkingList: [],
		silderMethod: [],
		//付款方式
		PaymentMode: [],
		//事件代码列表
		EventList: [],
		//平台动态信息
		IcpOperator: {},
		//收款商户列表
		PayeeMerchant: [],
		//当前用户按钮权限
		UserButton: [{
				path: 'EquipmentMonitoring',
				control: {
					select: true
				}
			},
			{
				path: 'RevenueMonitoring',
				control: {
					select: true
				}
			},
			{
				path: 'RealCharging',
				control: {
					stopCharging: true,
					ChargingCurves: true,
					select: true
				}
			}
		]
	},

	//组件计算方法
	getters: {
		// getPageUserButton: (state) => (path,type)=> {
		// 	console.log('getters');
		// 	console.log(path);
		// 	console.log(type);
		// 	let col=state.UserButton.find(item=>item.path==path)
		// 	return  col.control
		// }
	},

	//外部更改state只能通过此函数
	mutations: {
		increment(state, n) {
			state.Stations = n
		},
		upEquipmentModelDefine(state, n) {
			state.EquipmentModelDefine = n
		},
		upPriceModelDefine(state, n) {
			state.priceModelDefine = n
		},
		upPriceModelPowerDefine(state, n) {
			state.priceModelPowerDefine = n
		},
		upPriceModelJfpgDefine(state, n) {
			state.priceModelJfpgDefine = n
		},
		uptypeListDefine(state, n) {
			state.typeList = n
		},
		upManufacturerListDefine(state, n) {
			state.ManufacturerList = n
		},
		upRoleListDefine(state, n) {
			state.roleList = n
		},
		upCurrentUserInfo(state, n) {
			state.CurrentUserInfo = n
		},
		upChargeFronterListDefine(state, n) {
			state.chargeFronterList = n
		},
		upStationParkingListDefine(state, n) {
			state.StationParkingList = n
		},
		// upHasMenus(state,n){
		//  state.hasMenus=n
		// },
		upMenuList(state, n) {
			state.MenuList = n
		},
		upsilderMethod(state, n) {
			state.silderMethod = n
		},
		upPaymentMode(state, n) {
			state.PaymentMode = n
		},
		upIcpOperator(state, n) {
			state.IcpOperator = n
		},
		upEventList(state, n) {
			state.EventList = n
		},
		upPayeeMerchant(state, n) {
			state.PayeeMerchant = n
		},
		upUserButton(state, n) {
			state.UserButton = n
		},
	},
	//异步用来综合获得数据 再提交给mutations 去修改state
	actions: {
		//获得操作按钮
		GetUserButton(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/Home/GetCurrentUserButton", parms, {}).then(res => {
				console.log("用户操作按钮列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('upUserButton', res.data.Data.List)
				}
			})
		},
		GetUserStations(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/Home/GetCurrentUserStations", parms, {}).then(res => {
				console.log("站点列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('increment', res.data.Data.List)
				}
			})
		},
		GetEquipmentModelDefine(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/Archives/GetEquipmentModelDefine", parms, {}).then(res => {
				console.log("设备参数模板列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('upEquipmentModelDefine', res.data.Data.List)
				}
			})
		},
		GetPriceModelDefine(context) {
			let parms = {
				type: 1
			}
			axios.post(webapi.base_api_url + "/Archives/GetPriceTemplates", parms, {}).then(res => {
				console.log("价格模板列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('upPriceModelDefine', res.data.Data.List)
				}
			})
		},
		GetPriceModelPowerDefine(context) {
			let parms = {
				type: 2
			};
			axios.post(webapi.base_api_url + "/Archives/GetPriceTemplates", parms, {}).then((res => {
				if (res.data.Code == 0) {
					context.commit('upPriceModelPowerDefine', res.data.Data.List);
				}
			}))
		},
		GetPriceModelJfpgDefine(context) {
			let parms = {
				type: 3
			}
			axios.post(webapi.base_api_url + "/Archives/GetPriceTemplates", parms, {}).then(res => {
				console.log("价格模板列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('upPriceModelJfpgDefine', res.data.Data.List)
				}
			})
		},
		GetTypeListDefine(context) {
			let parms = {
				Type: 1
			}
			axios.post(webapi.base_api_url + "/Common/GetSelctListByType", parms, {}).then(res => {
				console.log("供应商列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('uptypeListDefine', res.data.Data.List)
				}
			})
			axios.post(webapi.base_api_url + "/Common/GetSelctListByType", {
				Type: 4
			}, {}).then(res => {
				console.log("付款方式store", res.data)
				if (res.data.Code == 0) {
					context.commit('upPaymentMode', res.data.Data.List)
				}
			})
			axios.post(webapi.base_api_url + "/Common/GetSelctListByType", {
				Type: 5
			}, {}).then(res => {
				console.log("付款方式store", res.data)
				if (res.data.Code == 0) {
					context.commit('upEventList', res.data.Data.List)
				}
			})
			axios.post(webapi.base_api_url + "/Common/GetSelctListByType", {
				Type: 6
			}, {}).then(res => {
				console.log("收款商户", res.data)
				if (res.data.Code == 0) {
					context.commit('upPayeeMerchant', res.data.Data.List)
				}
			})
		},
		GetRoleListDefine(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/System/GetRoles", parms, {}).then(res => {
				console.log("角色列表store", res.data)
				if (res.data.Code == 0) {
					context.commit('upRoleListDefine', res.data.Data.List)
				}
			})
		},
		GetCurrentUserInfo(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/Home/GetCurrentUserInfo", parms, {}).then(res => {
				console.log("获取当前用户信息", res.data)
				if (res.data.Code == 0) {
					context.commit('upCurrentUserInfo', res.data.Data)
				}
			})
		},
		GetChargeFronterList(context) {
			let params = {
				Type: 8
			};
			axios.post(webapi.base_api_url + '/Common/GetSelctListByType', params, {}).then(res => {
				if (res.data.Code == 0) {
					context.commit('upChargeFronterListDefine', res.data.Data.List);
				}
			});
		},
		getStationParkingList(context) {
			const params = {};
			axios.post(webapi.base_api_url + '/Common/GetStationParkingList', params, {}).then(res => {
				if (res.data.Code == 0) {
					context.commit('upStationParkingListDefine', res.data.Data.List);
				}
			});
		},
		GetManufacturerList(context) {
			let params = {
				Type: 7
			};
			axios.post(webapi.base_api_url + '/Common/GetSelctListByType', params, {}).then(res => {
				if (res.data.Code == 0) {
					context.commit('upManufacturerListDefine', res.data.Data.List);
				}
			});
		},
		GetMenuListInfo(context) {
			let parms = {
			}
			axios.post(webapi.base_api_url + "/Home/GetUserMenus", parms, {}).then(res => {
				console.log("获取当前菜单", res.data)
				if (res.data.Code == 0) {
					context.commit('upMenuList', res.data.Data.List)
				}
			})
		},
		GetIcpOperator(context, DomainName) {
			let parms = {
				DomainName: DomainName
			}
			axios.post(webapi.base_api_url + "/Home/GetIcpOperator", parms, {}).then(res => {
				console.log("获取域名信息", res.data)
				if (res.data.Code == 0) {
					context.commit('upIcpOperator', res.data.Data)
				}
			})
		}
	}
})

export default store
